module.exports = __webpack_public_path__ + "static/media/Android.c7e6049b.png";